import React from "react";
import { makeStyles } from "@material-ui/core";

let useStyles = makeStyles((theme) => ({
    root: {
        ...theme.grid.gridMdContent,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        textAlign: 'center',
        flexDirection: 'column',
        margin:'70px auto',
        maxWidth:'100%'
    },
    gridDesc: {
        width: '50%',
        minWidth:700,
        maxWidth:'100%',
        margin: 'auto',
           [theme.breakpoints.down("800")]: {
            minWidth:'100%',
        },
    },
    desc: {
        margin: 0,
        fontSize:16,
    },
    gridBtns: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop:'25px',
        [theme.breakpoints.down("375")]: {
          flexDirection:'column',
          width:'100%',
          '& > button':{
            width:'90%'
          }
        },
    },  
      btnRed: {
        margin: 5
    },
    btnWhite: {
        margin: 5,
        padding:'0px 33.5px',
    },
}))

export default function Index() {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <div className={classes['gridDesc']}>
                <p className={classes['desc']}>
                    بورس کالا، بازاری است که تعداد زیادی از عرضه‌کنندگان، کالای خود را عرضه کرده و متقاضیان کالاهای عرضه شده را خریداری می کنند. در این بازار معمولاً کالاهای خام و فرآوری نشده مانند فلزات، محصولات پتروشیمی، سیمان، محصولات کشاورزی و… دادوستد می‌شوند.
                </p>
                <p className={classes['desc']}>
                    البته به تازگی خودرو نیز به لیست کالاهای قابل معامله در بورس کالا اضافه شده است
                </p>
                <p className={classes['desc']}>
                    در این بازار، کالای مربوطه پس از بررسی‌های کارشناسی و قیمت‌گذاری توسط کارشناسان بورس کالا، به خریداران عرضه می‌شود.
                </p>
            </div>
            <div className={classes['gridBtns']}>
                <a href="https://pouyan.ebgo.ir/StockCode" target={'_blank'}>
                <button type="" className={`${classes['btnRed']} btnPouyanRed`}>
                    ثبت نام در بورس کالا
                </button>
                </a>
                <button type="" className={`${classes['btnWhite']} btnPouyanWhite`}>
                    اطلاعات بیشتر
                </button>
            </div>
        </div>)
}
